/* eslint-disable max-len */
/**
 * Polish translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {
    CHALLENGE_DESCRIPTION: 'Opis',
    END_DATE: 'Do',
    ID: 'Id',
    OBJECTIVE: 'Cel',
    REWARD: 'Nagroda',
    START_DATE: 'Od'
  },
  LABEL: {
    ACCUMULATED_VALUE: 'Skumulowana wartość',
    ACTIVES: 'Aktywa',
    AT: 'W',
    COUPON: 'Kupon',
    CREATED: 'Utworzony',
    DAY_VALUE: 'Dzień wartości',
    FAIL: 'Awaria',
    FINISHED: 'Zakończony',
    HISTORY: 'Historia',
    IN_PROGRESS: 'W toku',
    MONETARY_REWARD: 'Wartość premium',
    NR_ACCESSES: 'Liczba dostępów',
    NR_NEW_CLIENTS: 'Nowi klienci',
    NR_ORDERS: 'Liczba zamówień',
    OBJECTIVE: 'Cel',
    OBJECTIVE_VALUE: 'Wartość docelowa',
    OFFER: 'Oferta',
    OPEN: 'Otwarty',
    REMUNERATION: 'Wynagrodzenie',
    REWARD_TYPE: 'Rodzaj nagrody',
    REWARD_TYPES: 'Rodzaje nagród',
    SALES: 'Sprzedaż',
    SALES_BRANDS: 'Sprzedaż linii markowych (€)',
    SALES_BRANDS_QTY: 'Sprzedaż linii markowych (Qty)',
    SALES_CATEGORY: 'Kategoria sprzedaży (€)',
    SALES_CATEGORY_QTY: 'Sprzedaż w kategorii (ilość)',
    SALES_COMMISSIONS: 'Prowizje od sprzedaży',
    SALES_PRODUCTS: 'Sprzedaż produktów (€)',
    SALES_PRODUCTS_QTY: 'Sprzedaż produktów (Qty)',
    SUCCESS: 'Sukces',
    TO: '{0} do {1}',
    TODAY: 'Dzisiaj'
  },
  SENTENCE: {
    CHALLANGES_DESCRIPTION: 'Brak aktywnych wyzwań (jeszcze)',
    CHALLANGES_TITLE: 'Brak wyzwań.'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
